import { Box, Card, Grid, Stack, Typography } from '@mui/material'
import StatusText from 'common/component/StatusText'
import React, { useEffect, useMemo, useState } from 'react'
import defaultProductImage from '../../../assets/images/placeholderproduct.svg';
import colors from 'assets/theme/base/colors';
import { getStaticLegal } from '../../../redux/slices/common';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Loader from 'common/Loader';
import NoDataFound from 'common/component/NoDataFound';

const SameDayDeliveryPageDetail = ({ legalId, fullRoleTabSlug }) => {
  const { grey } = colors;
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
  const { singleLegal, isLoading } = useSelector((state => state.common));
  const [nodataFound, setNodataFound] = useState(false)
  const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);

  useEffect(() => {
    if (fullRoleTabheading) {
      dispatch(getStaticLegal({ id: fullRoleTabheading, platform: fullRoleTab })).unwrap().then(() => {
        setNodataFound(false)
      }).catch(() => {
        setNodataFound(true)
      });
    }
  }, [fullRoleTabheading, fullRoleTab])

  const sectionCard = (items) => (
    <>
      {items?.map((item, idx) => (
        <Stack key={item._id || idx} direction="column" spacing={1} flex={1} alignItems="center">
          <Box className="icon-field" display="flex" alignItems="center" justifyContent="center" flexDirection="row" gap={2} style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#ffd100", flexShrink: "0" }}>
            {
              Array.isArray(singleLegal?.weedDeliveryWorks?.section) &&
                singleLegal.weedDeliveryWorks.section.some(weedSection => weedSection._id === item._id) ? (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    color: "#000",
                    fontWeight: 700,
                    fontSize: "18px"
                  }}
                >
                  {idx + 1}
                </Box>
              ) : Array.isArray(singleLegal?.compliantCannabisDelivery?.section) &&
                singleLegal.compliantCannabisDelivery.section.some(compSection => compSection._id === item._id) ? (
                <Box
                  display="flex"
                  alignItems="start"
                  justifyContent="center"
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                  }}
                >
                  <svg
                    className="text-primary"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#FFD100"
                    width="28"
                    height="28"
                  >
                    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"></path>
                  </svg>
                </Box>
              ) : (
                item.image?.url && (
                  <Box
                    component="img"
                    src={item.image.url}
                    alt={item.image?.alt || item.title}
                    sx={{ width: 24, height: 24, objectFit: 'contain', flexShrink: 0 }}
                  />
                )
              )
            }


          </Box>
          <Box className="contents-field" display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap={1}>
            <Typography variant='h6' fontWeight="600">{item.title || "-"}</Typography>
            <Box
              variant="body2"
              color={grey[600]}
              style={{ width: "100%", textAlign: "center" }}
              dangerouslySetInnerHTML={{ __html: item.description || "" }}
            />
          </Box>
        </Stack>
      ))}
    </>
  )

  return (
    <>
      {isLoading ? <Loader /> : <>
        {nodataFound ? <NoDataFound /> :
          <Box p={4} pt={2} className="static-pages-container">

            {/**************** Page Title ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>{fullRoleTabheading}</Typography>
                <StatusText status={singleLegal?.status ? "active" : "inactive"} />
              </Stack>
            </Card>

            {/***************** Visible On ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2} mt={2}>
                <Typography variant='h5' fontWeight="semibold">Visible On</Typography>
              </Stack>
              <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                <Grid item xs={12}>
                  <Stack direction="row" alignItems="center" spacing={3}>
                    {singleLegal?.displaySettings?.footer && (
                      <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Footer</badge>
                    )}
                    {singleLegal?.displaySettings?.hamburgerMenu && (
                      <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hamburger Menu</badge>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Card>

            {/***************** Meta Properties ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">Meta Properties</Typography>
              </Stack>
              <Grid container alignItems="center" spacing={3} mb={2}>
                <Grid item xs={12}>
                  <Typography variant='body2' color={grey[600]} mb={1}>Meta Title</Typography>
                  <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.title || "-"}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                  <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.description || "-"}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' color={grey[600]} mb={1}>Updated By</Typography>
                  <Typography variant='h5' fontWeight="medium">{singleLegal?.createdBy || "-"}</Typography>
                </Grid>
              </Grid>
            </Card>

            {/***************** Header Section ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">Header Section</Typography>
                <StatusText status={singleLegal?.headerSection?.status ? "active" : "inactive"} />
              </Stack>
              {singleLegal?.headerSection?.status &&
                <div className="delivery-hero-grid">
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <span className="age-badge">{singleLegal?.headerSection?.badge || "-"}</span>

                      <h1 className="delivery-hero-title">{singleLegal?.headerSection?.pageTitle || "-"}</h1>

                      <div className="delivery-hero-desc">
                        <div
                          dangerouslySetInnerHTML={{ __html: singleLegal?.headerSection?.section?.description || "-" }}
                        />
                      </div>

                      {singleLegal?.headerSection?.cta?.length > 0 && (
                        <div className="button-group">
                          {singleLegal?.headerSection?.cta?.map((cta, idx) => (
                            <Stack
                              key={idx}
                              className="d-flex align-item-center flex-row  gap-2"
                              sx={idx === 0
                                ? { backgroundColor: '#ffd100', border: '1px solid #ffd100', borderRadius: 1.5, py: 1.5, px: 2.5 }
                                : { backgroundColor: 'transparent', border: '1px solid #000000', borderRadius: 1.5, py: 1.5, px: 2.5 }
                              }
                            >
                              <Typography variant='body2' fontWeight="600" style={{ fontSize: "14px", color: "#000000" }}>{cta?.name || "-"}</Typography>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
                            </Stack>
                          ))}
                        </div>
                      )}

                      {singleLegal?.headerSection?.points?.length > 0 && (
                        <div className="features-grid">

                          {singleLegal?.headerSection?.points?.map((point, idx) => (
                            <div key={idx} className="feature-item">
                              <div className="feature-icon-wrapper">
                                <svg className="lucide-circle-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#d7b20d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <circle cx="12" cy="12" r="10"></circle>
                                  <path d="m9 12 2 2 4-4"></path>
                                </svg>
                              </div>
                              <div className="feature-text">
                                <p className="feature-title">{point?.name}</p>
                                <p className="feature-desc">{point?.desc}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <div className="hero-image-container">
                        <img
                          style={{ borderRadius: '20px', width: '100%', minHeight: '450px', maxHeight: '500px', objectFit: 'cover' }}
                          src={singleLegal?.headerSection?.section?.image?.url || defaultProductImage}
                          alt="No Image Found"
                        />
                        <p className="image-badge">{singleLegal?.headerSection?.bannerBadge || "-"}</p>
                      </div>
                    </Grid>
                  </Grid>

                </div>
              }
            </Card>

            {/***************** Cannabis Delivery Today, Without the Dispensary Trip ****************/}
            {singleLegal?.dispensaryTrip?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Cannabis Delivery Today, Without the Dispensary Trip</Typography>
                  <StatusText status={singleLegal?.dispensaryTrip?.status ? "active" : "inactive"} />
                </Stack>

                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3} my={3}>
                  <Typography variant='h3' fontWeight="bold" style={{ width: '100%', textAlign: 'center' }}>{singleLegal?.dispensaryTrip?.pageTitle || "-"}</Typography>
                  <Box display="flex" justifyContent="center" gap={2} className="grid-three-columns icon-light-color">
                    {sectionCard(singleLegal?.dispensaryTrip?.section)}
                  </Box>
                  {singleLegal?.dispensaryTrip?.description && (
                    <Typography variant='body2' fontWeight="medium" style={{ width: '100%', textAlign: 'center' }}>{singleLegal?.dispensaryTrip?.description}</Typography>
                  )}
                </Box>
              </Card>
            }

            {/***************** How Same-Day Weed Delivery Works ****************/}
            {singleLegal?.weedDeliveryWorks?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">How Same-Day Weed Delivery Works</Typography>
                  <StatusText status={singleLegal?.weedDeliveryWorks?.status ? "active" : "inactive"} />
                </Stack>

                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3} my={3}>
                  <Typography variant='h3' fontWeight="bold" style={{ width: '100%', textAlign: 'center' }}>{singleLegal?.weedDeliveryWorks?.pageTitle || "-"}</Typography>
                  <Box display="flex" justifyContent="center" gap={2} className="grid-three-columns">
                    {sectionCard(singleLegal?.weedDeliveryWorks?.section)}
                  </Box>
                  {/* {singleLegal?.dispensaryTrip?.description && (
                    <Typography variant='body2' fontWeight="medium" style={{ width: '100%', textAlign: 'center' }}>{singleLegal?.dispensaryTrip?.description}</Typography>
                  )} */}
                </Box>
              </Card>
            }

            {/***************** Same-Day Delivery Timing ****************/}
            {singleLegal?.sameDayDeliveryTiming?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Same-Day Delivery Timing</Typography>
                  <StatusText status={singleLegal?.sameDayDeliveryTiming?.status ? "active" : "inactive"} />
                </Stack>
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3} my={3}>
                  <Typography variant='h3' fontWeight="bold" style={{ width: '100%', textAlign: 'center' }}>{singleLegal?.sameDayDeliveryTiming?.pageTitle || "-"}</Typography>
                  <Box display="flex" justifyContent="center" gap={2} className="grid-auto-columns same-day-delivery-timing">
                    {sectionCard(singleLegal?.sameDayDeliveryTiming?.section)}
                  </Box>
                </Box>
              </Card>
            }

            {/***************** Same-Day Weed Delivery Areas ****************/}
            {singleLegal?.deliveryAreas?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Same-Day Weed Delivery Areas</Typography>
                  <StatusText status={singleLegal?.deliveryAreas?.status ? "active" : "inactive"} />
                </Stack>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Page Title (H1)</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.deliveryAreas?.pageTitle || "-"}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                    <Typography
                      variant="h5"
                      fontWeight="medium"
                      dangerouslySetInnerHTML={{ __html: singleLegal?.deliveryAreas?.description || "-" }}
                    />
                  </Grid>
                </Grid>
              </Card>
            }

            {/***************** Why Choose Hyperwolf for Weed Delivery? ****************/}
            {singleLegal?.hyperwolfForWeedDelivery?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Why Choose Hyperwolf for Weed Delivery?</Typography>
                  <StatusText status={singleLegal?.hyperwolfForWeedDelivery?.status ? "active" : "inactive"} />
                </Stack>

                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3} my={3}>
                  <Typography variant='h3' fontWeight="bold" style={{ width: '100%', textAlign: 'center' }}>{singleLegal?.hyperwolfForWeedDelivery?.pageTitle || "-"}</Typography>
                  <Box gap={2} className="grid-four-columns">
                    {singleLegal?.hyperwolfForWeedDelivery?.section?.map((item, idx) => (
                      <Stack key={item._id || idx} direction="row" spacing={2} alignItems="center">
                        {item.image?.url && (
                          <Box className="icon-field" display="flex" alignItems="center" justifyContent="center" flexDirection="row" gap={2} style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#ffedb3" }}>
                            {item.image?.url && (
                              <Box
                                component="img"
                                src={item.image.url}
                                alt={item.image?.alt || item.title}
                                sx={{ width: 24, height: 24, objectFit: 'contain', flexShrink: 0 }}
                              />
                            )}
                          </Box>
                        )}
                        <Typography variant='h6' fontWeight="600">{item.title || "-"}</Typography>
                      </Stack>
                    ))}
                  </Box>
                </Box>
              </Card>
            }

            {/***************** Safe, Licensed & Compliant Cannabis Delivery ****************/}
            {singleLegal?.compliantCannabisDelivery?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Safe, Licensed & Compliant Cannabis Delivery</Typography>
                  <StatusText status={singleLegal?.compliantCannabisDelivery?.status ? "active" : "inactive"} />
                </Stack>
                <Box
                  style={{
                    border: "1px solid #ededed",
                    padding: "30px",
                    borderRadius: "6px",
                    maxWidth: "1024px",
                    margin: "auto"
                  }}
                >
                  <Grid container spacing={3}>
                    {singleLegal?.compliantCannabisDelivery?.image?.url && (
                      <Grid item xs={12}>
                        {/* <Typography variant='body2' color={grey[600]} mb={1}>Icon</Typography> */}
                        <Box className="icon-field" display="flex" alignItems="center" justifyContent="center" flexDirection="row" gap={2} style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#ffd100", margin: "auto" }}>
                          <Box
                            component="img"
                            src={singleLegal?.compliantCannabisDelivery?.image?.url}
                            alt={singleLegal?.compliantCannabisDelivery?.image?.alt || "icon"}
                            sx={{ width: 24, height: 24, objectFit: 'contain' }}
                          />
                        </Box>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      {/* <Typography variant='body2' color={grey[600]} mb={1}>Section Title (H2)</Typography> */}
                      <Typography variant='h3' fontWeight="semibold" style={{ textAlign: "center" }}>{singleLegal?.compliantCannabisDelivery?.pageTitle || "-"}</Typography>
                    </Grid>
                    {singleLegal?.compliantCannabisDelivery?.section?.length > 0 && (
                      <Grid item xs={12}>
                        {/* <Typography variant='body2' color={grey[600]} mb={2}>Section Items</Typography> */}
                        <Box gap={2} className="grid-two-columns safe-licensed-sec">
                          {sectionCard(singleLegal?.compliantCannabisDelivery?.section)}
                        </Box>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <Box
                        style={{
                          background: "#f9f9f9",
                          border: "1px solid #ededed",
                          borderRadius: "12px",
                          padding: "16px"
                        }}
                      >
                        <div
                          className="font-size-14"
                          dangerouslySetInnerHTML={{ __html: singleLegal?.compliantCannabisDelivery?.description || "-" }}
                        />
                      </Box>
                    </Grid>
                    {singleLegal?.compliantCannabisDelivery?.content1 && (
                      <Grid item xs={12}>
                        {/* <Typography variant='body2' color={grey[600]} mb={1}>Content 1</Typography> */}
                        <Box
                          style={{
                            background: "#f9f9f9",
                            border: "1px solid #ededed",
                            borderRadius: "12px",
                            padding: "16px"
                          }}
                        >
                          <div
                            className="font-size-14"
                            dangerouslySetInnerHTML={{ __html: singleLegal?.compliantCannabisDelivery?.content1 }}
                          />
                        </Box>
                      </Grid>
                    )}
                    {singleLegal?.compliantCannabisDelivery?.content2 && (
                      <Grid item xs={12}>
                        {/* <Typography variant='body2' color={grey[600]} mb={1}>Content 2</Typography> */}
                        <Box
                          style={{
                            background: "#f9f9f9",
                            border: "1px solid #ededed",
                            borderRadius: "12px",
                            padding: "16px"
                          }}
                        >
                          <div
                            className="font-size-14"
                            dangerouslySetInnerHTML={{ __html: singleLegal?.compliantCannabisDelivery?.content2 }}
                          />
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Card>
            }

            {/***************** FAQ ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">FAQs</Typography>
                <StatusText status={singleLegal?.faq?.status ? "active" : "inactive"} />
              </Stack>
              {singleLegal?.faq?.status && <>
                {singleLegal?.faq?.section?.length !== 0 ?
                  <Grid container alignItems="center">
                    {singleLegal?.faq?.section?.map((data, idx) => (
                      <Grid item xs={12} mb={2} key={data._id || idx}>
                        <Typography
                          variant="h5"
                          fontWeight="medium"
                          dangerouslySetInnerHTML={{ __html: data?.question || "-" }}
                        />
                        <Typography
                          variant="body2"
                          color={grey[600]}
                          dangerouslySetInnerHTML={{ __html: data?.answer || "-" }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                  : <NoDataFound />
                }
              </>}
            </Card>

            {/***************** Footer Section ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">Footer Section</Typography>
                <StatusText status={singleLegal?.footerSection?.status ? "active" : "inactive"} />
              </Stack>
              {singleLegal?.footerSection?.status &&
                <div className="delivery-hero-grid">
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={6}>
                      <h2 className="delivery-hero-title">{singleLegal?.footerSection?.pageTitle || "-"}</h2>

                      <div className="delivery-hero-desc">
                        <Typography
                          variant="h5"
                          fontWeight="medium"
                          dangerouslySetInnerHTML={{ __html: singleLegal?.footerSection?.section?.description || "-" }}
                        />
                      </div>

                      {singleLegal?.footerSection?.cta?.length > 0 && (
                        <div className="button-group">
                          {singleLegal?.footerSection?.cta?.map((cta, idx) => (
                            <Stack
                              key={idx}
                              className="d-flex align-item-center flex-row  gap-2"
                              sx={idx === 0
                                ? { backgroundColor: '#000000', color: '#ffd100', border: '1px solid #000000', borderRadius: 1.5, py: 1.5, px: 2.5 }
                                : { backgroundColor: 'transparent', border: '1px solid #000000', borderRadius: 1.5, py: 1.5, px: 2.5 }
                              }
                            >
                              <Typography variant='body2' fontWeight="600" style={{ fontSize: "14px" }}>{cta?.name || "-"}</Typography>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
                            </Stack>
                          ))}
                        </div>
                      )}

                    </Grid>
                    <Grid item xs={12} md={6}>
                      <div className="hero-image-container">
                        <img
                          style={{ borderRadius: '20px', width: '100%', minHeight: '450px', maxHeight: '500px', objectFit: 'cover' }}
                          src={singleLegal?.footerSection?.section?.image?.url || defaultProductImage}
                          alt="No Image Found"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              }
            </Card>

          </Box>
        }
      </>}
    </>
  )
}

export default SameDayDeliveryPageDetail
